/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Url/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Url({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Documents/Navigation/Actions/CreateVirtualFile/Content/Url",
  onChange,
  isInvalid
  
}) {
let virtualFileUrlValueData = fromData.useDataValue({ viewPath,
context: 'virtual_file',
path: 'url',
})
let virtualFileUrlIsValidData = fromData.useDataIsValid({ viewPath,
context: 'virtual_file',
path: 'url',
validate: fromValidate.isValidUrl,
required: true,
})
let virtualFileUrlChangeData = fromData.useDataChange({ viewPath,
context: 'virtual_file',
path: 'url',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 width="100%"
 marginTop={dtSpaceS}
 data="virtual_file.url"
 value={virtualFileUrlValueData}
 onChange={virtualFileUrlChangeData}
 required={true}
 validate="/Data/validate.js isValidUrl"
 invalid={!virtualFileUrlIsValidData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="URL"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 placeholder="https://..."
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}